// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  defaults: {
    VTextField: {
      variant: 'outlined',
      density: 'compact',
      color: 'primary',
    },
    VTextarea: {
      variant: 'outlined',
      density: 'compact',
      color: 'primary',
    },
    VSelect: {
      variant: 'outlined',
      density: 'compact',
      color: 'primary',
      menuProps: { maxWidth: '100vw' },
    },
    VCombobox: {
      variant: 'outlined',
      density: 'compact',
      color: 'primary',
      menuProps: { maxWidth: '100vw' },
    },
    VAutocomplete: {
      variant: 'outlined',
      density: 'compact',
      color: 'primary',
      menuProps: { maxWidth: '100vw' },
    },
    VFileInput: {
      variant: 'outlined',
      density: 'compact',
      color: 'primary',
    },
    VCard: {
      variant: 'flat',
      elevation: 0,   
    },
    VSwitch: {
      color: 'primary',
    },
    VRadioGroup: {
      color: 'primary',
    },
    VBtn: {
      color: 'primary',
      variant: 'flat',
      rounded: true,
      class: 'text-none',
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          // primary: '#7f4d93', // UComms Branding color
        },
      },
      dark: {
        colors: {
          // primary: '#7f4d93', // UComms Branding color
        },
      },
    },
  },
});
